import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export const About = () => {
  return <section id="about" className="py-20 bg-pattern-dark" data-id="element-18">
      <div className="container mx-auto px-4" data-id="element-19">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-20">
          <div className="lg:w-1/2" data-id="element-21">
            <div className="relative" data-id="element-22">
              <img src="https://images.unsplash.com/photo-1589579234096-07c4f25f5492?q=80&w=2787&auto=format&fit=crop" alt="" className="rounded-xl" data-id="element-23" />
            </div>
          </div>
          <div className="lg:w-1/2" data-id="element-24">
            <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="element-25">
              About <span className="text-red-500" data-id="element-26">Chicago Kush</span>
            </h2>
            <p className="text-gray-300 mb-8" data-id="element-27">
              Chicago Kush was founded with a simple mission: to provide premium
              quality cannabis products that enhance life's moments. Our team of
              expert cultivators and passionate cannabis advocates work
              tirelessly to bring you the finest selection of strains and
              products.
            </p>
            <div className="space-y-4 mb-8" data-id="element-28">
              <div className="flex items-start" data-id="element-29">
                <CheckCircleIcon className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-30" />
                <p className="text-gray-300" data-id="element-31">
                  Organically grown with sustainable practices
                </p>
              </div>
              <div className="flex items-start" data-id="element-32">
                <CheckCircleIcon className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-33" />
                <p className="text-gray-300" data-id="element-34">
                  Rigorous lab testing for quality and purity
                </p>
              </div>
              <div className="flex items-start" data-id="element-35">
                <CheckCircleIcon className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-36" />
                <p className="text-gray-300" data-id="element-37">
                  Award-winning strains cultivated by experts
                </p>
              </div>
              <div className="flex items-start" data-id="element-38">
                <CheckCircleIcon className="text-red-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-39" />
                <p className="text-gray-300" data-id="element-40">
                  Community-focused and locally owned
                </p>
              </div>
            </div>
            <a href="#" className="font-display italic inline-block bg-red-600 hover:bg-red-700 text-white py-3 px-8 rounded-full transition duration-300" data-id="element-41">
              Learn More About Us
            </a>
          </div>
        </div>
      </div>
    </section>;
};